import { MailSendFlowComponent } from '@agent-ds/shared/components/mail-send-flow/mail-send-flow.component';
import { MailSendConfig } from '@agent-ds/shared/components/mail-send/config';
import { getValueFromObject } from '@agent-ds/shared/util/util';
import { StudentDetailPageComponent } from '@agent-ds/student/pages/student-detail-page/student-detail-page.component';
import { StudentTabs } from '@agent-ds/student/pages/student-detail-page/tabs/student-tabs';
import { ProgressItemResponse } from '../interfaces';
import { DetailPage } from '../models';
import { CompanyDetailPageComponent } from '@agent-ds/company/pages';

export function openStudentDetail(selectedItem: any): void {
  StudentDetailPageComponent.instance.referenceId = selectedItem ? selectedItem.id : null;
  StudentDetailPageComponent.instance.open();
}

export function openStudentDetailMemo(selectedItem: any): void {
  StudentDetailPageComponent.instance.referenceId = selectedItem ? selectedItem.id : null;
  StudentDetailPageComponent.instance.selectedTabIndex = StudentTabs.MEMO;
  StudentDetailPageComponent.instance.open();
}

export function openStudentMailSend(config: MailSendConfig, student: any): void {
  StudentDetailPageComponent.instance.referenceId = student ? student.id : null;
  StudentDetailPageComponent.instance.open();
  MailSendFlowComponent.instance.config = config;
  config.setParams({
    student: {
      id: student.id,
      frontId: student.frontId,
      firstName: student.dynamicData.firstName,
      lastName: student.dynamicData.lastName,
      age: null,
      prefecture: null,
      schoolName: null,
      schoolDepartmentName: null,
      studentUser: student.studentUsers,
      emailMain: getValueFromObject(student, 'dynamicData.emailMain.email'),
      emailMainAvailable: getValueFromObject(student, 'dynamicData.emailMain.emailAvailable'),
      emailSub: getValueFromObject(student, 'dynamicData.emailSub.email'),
      emailSubAvailable: getValueFromObject(student, 'dynamicData.emailSub.emailAvailable'),
    },
  });
  MailSendFlowComponent.instance.start();
}

export function openEnterpriseDetail(progress: ProgressItemResponse): void {
  onLinkClick(CompanyDetailPageComponent.instance, resolveEnterpriseId(progress));
}
export function openEnterpriseDetailWithId(enterpriseId): void {
  onLinkClick(CompanyDetailPageComponent.instance, enterpriseId);
}

function onLinkClick(instance: DetailPage, id: number | null): void {
  if (id) {
    instance.referenceId = id;
    instance.open();
  }
}

function resolveEnterpriseId(progress: ProgressItemResponse): number | null {
  if (!progress) {
    return null;
  }

  const progressJob = (progress as any).job || {};
  const enterpriseDepartment = progressJob.enterpriseDepartment || {};
  const jobEnterprise = enterpriseDepartment.enterprise || {};
  const progressEnterprise = (progress as any).enterprise || {};

  return jobEnterprise.id || progressEnterprise.id || null;
}
